/**
 * Is used to identify insights fields within the components to set their visibilities.
 */
export enum InsightsType {
  CUSTOMER_INSIGHTS = 'CUSTOMER_INSIGHTS',
}
